import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimeAgo } from 'shared/utils';
import { getOpenJobCardTheme } from '../openJobCardThemes';
import {
	getJobCode,
	getJobDisplayTitle,
	getJobIndustry,
	getJobLocations,
	getJobSchedule
} from '../openJobsData';

export default function OpenJobCard({ job, index }) {
	const theme = getOpenJobCardTheme(index);

	const metaRows = [
		{ icon: '/ats/icons/clients-gray-icon.svg', text: getJobIndustry(job) },
		{ icon: '/ats/icons/calendar-gray-icon.svg', text: getJobSchedule(job) },
		{ icon: '/ats/icons/location-gray-icon.svg', text: getJobLocations(job) }
	].filter(row => row.text);

	return (
		<Link className={`open-job-card is-${theme.tone}`} to={`/jobs/${job.id}`}>
			<div
				className="open-job-card-header"
				style={{ backgroundColor: theme.background }}>
				<div className="open-job-card-header-top">
					<span className="open-job-card-code">{getJobCode(job)}</span>
					<span className="open-job-card-date">
						{job.createdAt ? formatTimeAgo(new Date(job.createdAt)) : null}
					</span>
				</div>
				<div className="open-job-card-header-bottom">
					<h2 className="open-job-card-title">{getJobDisplayTitle(job)}</h2>
					<span className="open-job-card-arrow">
						<img src={theme.arrowIcon} alt="" />
					</span>
				</div>
			</div>
			<div className="open-job-card-meta">
				{metaRows.map(row => (
					<div className="open-job-card-meta-row" key={row.icon}>
						<span className="open-job-card-meta-icon">
							<img src={row.icon} alt="" />
						</span>
						<span className="open-job-card-meta-text">{row.text}</span>
					</div>
				))}
			</div>
		</Link>
	);
}
